module.exports = __webpack_public_path__ + "img/italy.f04de15f.svg";